import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const adyen = defineConnector({
  identifier: "adyen",
  name: "Adyen",
  tagLine: "Payment processing platform",
  keywords: "payments checkout psp gateway management kyc",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.adyen\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Adyen instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Adyen instance.",
        },
        {
          kind: "input",
          label: "Environment",
          placeholder: "live|test",
          required: true,
          target: { kind: "configuration", field: "environment" },
          helperText: "Use 'test' for sandbox or 'live' for production.",
        },
        {
          kind: "input",
          label: "Resource",
          placeholder: "kyc",
          required: true,
          target: { kind: "configuration", field: "resource" },
          helperText:
            "The API resource prefix, e.g. 'management', 'checkout', or 'kyc'.",
        },
      ],
    },
    {
      title: "Create an Adyen OAuth client",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Adyen Customer Area](https://ca-live.adyen.com/), navigate to **Developers > API credentials** and create a new credential with type **OAuth**. You'll need an account with admin permissions to do this.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content:
            "In your OAuth credential’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/adyen/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Adyen account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Adyen account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://ca-${configuration.environment}.adyen.com/ca/ca/oauth/connect.shtml`,
    tokenEndpoint: (configuration) =>
      `https://oauth-${configuration.environment}.adyen.com/v1/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://management-${configuration.environment}.adyen.com/v3/me`,
  },
  publicEnvVars: ({ environment, resource }) => ({
    ADYEN_ENVIRONMENT: environment || "",
    ADYEN_RESOURCE: resource || "",
  }),
});
